import * as yup from 'yup';

import { Insurance } from 'constants/routes';
import { genderMap, genderReversMap } from 'store/insuranceAnketa/genderHelper';

import { generateNumberMask } from './Insurance.helpers';

const { ROUTE_NAMES } = Insurance;

export const STEPS = [
  {
    routes: new Set([ROUTE_NAMES.CREATE_NEW, ROUTE_NAMES.VEHICLE_INFORMATION]),
    title: 'Сведения о транспортном средстве',
  },
  { routes: new Set([ROUTE_NAMES.POLICYHOLDER]), title: 'Страхователь' },
  { routes: new Set([ROUTE_NAMES.DRIVERS]), title: 'Список водителей' },
  { routes: new Set([ROUTE_NAMES.INSURANCE_PRODUCTS]), title: 'Продукты страхования' },
  { routes: new Set([ROUTE_NAMES.INSURANCE_PROGRAMS]), title: 'Программы страхования' },
  { routes: new Set([ROUTE_NAMES.UNDERWRITING]), title: 'Андеррайтинг' },
  { routes: new Set([ROUTE_NAMES.PAYMENT]), title: 'Оплата' },
];

export const VALIDATION_TYPES = {
  INCORRECT: 'incorrect',
  REQUIRED: 'required',
  VOID: 'void',
};

export const VOID_VALIDATION = yup.mixed().test(VALIDATION_TYPES.VOID, '', () => {
  return true;
});

export const GENDERS = [
  { id: genderMap.MALE, sysName: genderReversMap[genderMap.MALE], value: 'Мужской' },
  { id: genderMap.FEMALE, sysName: genderReversMap[genderMap.FEMALE], value: 'Женский' },
];

export const MAX_DATE = new Date();
export const MIN_DATE = new Date('1900');
export const OUTPUT_CUSTOMER_DATE_FORMAT = 'DDMMYYYY';

export const DATA_TESTS = {
  VIN_RECOGNITION_BUTTON: 'vin-recognition-button',
  VIN_RECOGNITION_INFO_BUBBLE: 'vin-recognition-info-bubble',
};

export const NUMBER_MAX_99_MASK = generateNumberMask({ min: 0, max: 99 });
